import type { EpochMetricId } from "../shared/contracts.ts";

/** Labels only; all score eligibility and layout use the model-first pipeline. */
export const EPOCH_METRICS: ReadonlyArray<{ key: EpochMetricId; short: string; label: string }> = [
  { key: "general", short: "General", label: "General ECI" },
  { key: "software-engineering", short: "Software Engineering", label: "Software engineering" },
  { key: "math", short: "Math", label: "Math" },
  { key: "cyber", short: "Cyber", label: "Cyber" },
];
